<template>
  <!-- 查看详情页面 -->
  <Modal :value.sync="show" @on-cancel="show = false" :title="title" fullscreen>
    <div id="printArea">
      <p class="text-c" style="padding: 20px 0; font-weight: blod">
        温室气体重点排放单位信息公开表
      </p>
      <!-- 基础表单 -->
      <table class="table1">
        <tr>
          <td colspan="2">
            D.1 基本信息
          </td>
        </tr>
        <tr>
          <td>重点排放单位名称</td>
          <td>{{ baseInfo.companyName }}</td>
        </tr>
        <tr>
          <td>统一社会信用代码</td>
          <td>{{ baseInfo.identityCode }}</td>
        </tr>
        <tr>
          <td>排污许可证编号</td>
          <td>{{ baseInfo.permitCode }}</td>
        </tr>
        <tr>
          <td>法定代表人姓名</td>
          <td>{{ baseInfo.legalPerson }}</td>
        </tr>
        <tr>
          <td>生产经营场所地址及邮政编码（省、市、 县、详细地址）</td>
          <td>{{ baseInfo.manufactureAddress }}，{{baseInfo.postalCode}}</td>
        </tr>
        <tr>
          <td>行业分类</td>
          <td>{{ baseInfo.companyIndustryName }}</td>
        </tr> 
        <tr>
          <td>纳入全国碳市场的行业子类</td>
          <td>{{ baseInfo.guideIndustryType }}</td>
        </tr>

        <tr>
          <td colspan="2">D.2 机组及生产设施信息</td>
        </tr>
      </table>
      <!-- 机组及生产设施信息 -->
      <table class="table2" v-if="otherForm.unitInfo=='Y'">
        <tr>
          <td>机组名称</td>
          <td>信息项</td>
          <td>内容</td>
        </tr>
        <tr v-for="(item, index) in unitList" :key="index">
          <td :rowspan="5" v-if="index % 5 === 0" style="width: 230px">
            {{ item.unitName }}
          </td>
          <td>{{ item.keyStr }}</td>
          <td>{{ item.keyData }}</td>
        </tr>
      </table>
      <!-- 确定方式表 -->
      <table class="table4">
        <tr>
          <td colspan="15">
            D.3 低位发热量和元素碳含量的确定方式（排放报告-确定方式表）
          </td>
        </tr>
        <tr class="text-c">
          <td rowspan="2" style="width: 100px">机组</td>
          <td rowspan="2" style="width: 100px">参数</td>
          <td rowspan="2">月份</td>
          <td colspan="4">自行检测</td>
          <td colspan="4">委托检测</td>
          <td>未实测</td>
        </tr>
        <tr class="text-c">
          <td>检测设备</td>
          <td>检测频次</td>
          <td>设备校准频次</td>
          <td>测定方法标准</td>
          <td>委托机构名称</td>
          <td>检测报告编号</td>
          <td>检测日期</td>
          <td>测定方法标准</td>
          <td>缺省值</td>
        </tr>
        <tr v-for="(item, index) in determineWays" :key="index" class="text-c">
          <td :rowspan="24" v-if="index % 24 === 0">{{ item.unitName }}</td>
          <td :rowspan="12" v-if="index % 12 === 0">{{ item.infoItem === '单位热值含碳量' ? '元素碳含量' : item.infoItem}}</td>
          <td>{{ item.month }}</td>
          <td>{{ item.testEquipment }}</td>
          <td>{{ item.frequencyDetection }}</td>
          <td>{{ item.calibrationFrequency }}</td>
          <td>{{ item.methodStandard }}</td>
          <td>{{ item.institutionName }}</td>
          <td>{{ item.reportNumber }}</td>
          <td>{{ item.testDate }}</td>
          <td>{{ item.methodStandard2 }}</td>
          <td>{{ item.defaultValue }}</td>
        </tr>

        <tr>
          <td colspan="15">D.4 排放量信息</td>
        </tr>
        <tr v-if="otherForm.emissions==='Y'">
          <td colspan="5">全部机组二氧化碳排放总量（tCO2）</td>
          <td colspan="10">{{ otherForm.totalUnitEmission }}</td>
        </tr>
        <tr>
          <td colspan="15">D.5 生产经营变化情况</td>
        </tr>
        <tr>
          <td colspan="15" style="height: 200px">
            <p v-html="baseInfo.companyIntroduction"></p>
          </td>
        </tr>
        <tr>
          <td colspan="15">D.6 编制温室气体排放报告的技术服务机构情况</td>
        </tr>
        <tr>
          <td colspan="15">
            编制温室气体排放报告的技术服务机构名称：{{
              otherForm.technicalServiceOrgName
            }}
          </td>
        </tr>
        <tr>
          <td colspan="15">
            编制温室气体排放报告的技术服务机构统一社会信用代码：{{
              otherForm.technicalServiceOrgCreditCode
            }}
          </td>
        </tr>
        <tr>
          <td colspan="15">D.7 清缴履约情况</td>
        </tr>
        <tr>
          <td colspan="15">
            <span>重点排放单位是否完成对应履约期的配额清缴与履约：</span>
            {{otherForm.appointStatus === 'Y' ? '完成' : otherForm.appointStatus === 'N' ? '未完成' : '未纳入碳市场'}}
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer">
      <Button type="text" @click="show=false" v-if="!onlyView">取消</Button>
      <Button type="primary" class="btn-c-common" @click="modalOk" v-if="!onlyView">公开</Button>
      <Button type="primary" class="btn-c-common" @click="show=false" v-if="onlyView">关闭</Button>
      <!-- <Button type="primary" class="btn-c-common" v-print="print">公开</Button> -->
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    onlyView: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    unitInfoList: {
      type: Array,
      default: () => [],
    },
    determineWays: {
      type: Array,
      default: () => [],
    },
    otherForm: {
      type: Object,
      default: () => {
        return {
            totalUnitEmission:'',
            technicalServiceOrgName:'',
            technicalServiceOrgCreditCode:'',
            appointStatus:''
        };
      },
    },
  },
  computed: {
     ...mapGetters(["getUserInfo"]),
     companyId() {
        return this.getUserInfo.user.companyId;
    },
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        // console.log('changeShow::::', val)
        this.$emit("update:visible", val); // visible 改变的时候通知父组件
      },
    },
    unitList() {
      let data = [];
      let keyArr = [
        { key: "fuelType", name: "燃料类型" },
        { key: "unitType", name: "机组类型" },
        { key: "capacityVal", name: "装机容量（MW）" },
        { key: "boilerVal", name: "锅炉类型" },
        { key: "coolingModeVal", name: "汽轮机排汽冷却方式" },
      ];
      this.unitInfoList.forEach((item) => {
        keyArr.forEach((_item) => {
          data.push({
            unitName: item.unitName,
            keyStr: _item.name,
            keyData: item[_item.key],
          });
        });
      });
      return data;
    },
  },
  data() {
    return {
      print: {
        id: "printArea",
      },
    };
  },
  methods: {
    modalOk() {
      
      let parmas = {
        info:{
        companyId:this.companyId,
        year:this.otherForm.year,
        industryCode:this.otherForm.industryCode,
        industryName:this.otherForm.industryName,
        basicInfo:'Y',
        unitInfo:this.otherForm.unitInfo,
        lowCarbonCalorific:'Y',
        emissions:this.otherForm.emissions,
        productionOperation:'Y',
        technicalServiceOrgName:this.otherForm.technicalServiceOrgName,
        technicalServiceOrgCreditCode:this.otherForm.technicalServiceOrgCreditCode,
        appointStatus:this.otherForm.appointStatus,
        totalUnitEmission:this.baseInfo.totalUnitEmission,
        postalCode:this.baseInfo.postalCode,
        companyIntroduction:this.baseInfo.companyIntroduction,
        companyName:this.baseInfo.companyName,
        identityCode:this.baseInfo.identityCode,  
        permitCode:this.baseInfo.permitCode,
        legalPerson:this.baseInfo.legalPerson,
        manufactureAddress:this.baseInfo.manufactureAddress,
        companyIndustryName:this.baseInfo.companyIndustryName,
        guideIndustryType:this.baseInfo.guideIndustryType,
        },
       
        unitInfoList: this.otherForm.unitInfo=='Y' ? this.unitInfoList : [],
        determineWayList:this.determineWays
      }
      this.$emit('onSuccess', parmas)
      this.show = false;
      // this.getPdf( document.querySelector('#printArea'),'我的PDF');
    },
  },
};
</script>


<style lang="less" scoped>
// 预览默认横向
@page {
  size: landscape;
  margin-top: 1mm; //去掉页眉
  margin-bottom: 1mm; //去掉页脚
}
#printArea{
  background-image: url('../../../assets/MEE3.gif');
  background-repeat: repeat-y;
  background-position: center -30px;
  background-size:860px 810px;
}
table {
  border-collapse: collapse;
  width: 100%;
  td {
    border: 1px solid #000;
    padding: 3px 0 3px 4px;
  }
}
.table1 {
  tr > td:first-of-type {
    width: 230px;
  }
  tr:last-of-type > td {
    border-bottom: none;
  }
}
.table2 {
  text-align: center;
  tr:last-of-type > td {
    border-bottom: none;
  }
}
// .table4 {
//     margin-top: 50px;
// }
</style>